import React from 'react';
import numberFormat from "../../../helpers/numberFormat";
import RenderStandartTablePart from "./renderStandartTablePart";

const RenderGroup = ({table,fromGoogle,somthingWithCategory,categories}) => {

  const removeCategory = () =>{
    if(window.confirm('Вы действительно хотите удалить '+table.name)){
      somthingWithCategory({id:table.id, type:'delete'})
    }

  }
  if(table.type === 'category'){
    return<>
      <tr>
        <th colSpan={4} style={{paddingLeft: '1rem'}}>{table.name}</th>
        <th className={'text-end'}>{numberFormat(table.total)}</th>
        <th colSpan={2}>KZT</th>
        <td className={'text-center'}>
          <i className={'fa fa-trash pointer'} onClick={removeCategory}/>
        </td>
      </tr>
      {table.values.map((tv,i)=>{
        return <React.Fragment key={i}>
          <RenderStandartTablePart table={tv}
                                   somthingWithCategory={somthingWithCategory}
                                   categories={categories}/>
        </React.Fragment>
      })}
    </>
  }
  return <RenderStandartTablePart table={table}
                                  fromGoogle={fromGoogle}
                                  categories={categories}
                                  somthingWithCategory={somthingWithCategory}/>
};

export default RenderGroup;




